import { useState } from 'react';
import { todayMeta } from '@/mocks/gossipData';

const links = [
          { key: 'fresh', label: '今日新料', icon: 'ri-flashlight-line' },
          { key: 'heat', label: '热度飙升', icon: 'ri-fire-line' },
          { key: 'topic', label: '瓜棚追更', icon: 'ri-stack-line' },
          { key: 'pending', label: '待爆预警', icon: 'ri-time-line' },
];

export default function NavBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/85 backdrop-blur">
      <div className="mx-auto flex items-center justify-between px-4 md:px-6 py-3">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-600 text-background-50">
            <i className="ri-news-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">
              黑吃瓜
            </span>
            <span className="mt-0.5 text-[10px] tracking-widest text-primary-600">
              黑料速递
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.key}
              href={`#${l.key}`}
              className="flex items-center gap-1.5 rounded-full px-4 py-2 text-sm text-foreground-700 hover:bg-primary-100 hover:text-primary-800 whitespace-nowrap cursor-pointer"
            >
              <i className={l.icon} />
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#heat"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-md border border-primary-200 bg-primary-100 px-3 py-2 text-xs font-semibold text-primary-800 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-flashlight-line" />
            今日已更 {todayMeta.count}
          </a>
          <button
            onClick={() => setOpen(true)}
            className="md:hidden flex h-9 w-9 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-800 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className="ri-menu-line" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.key}
                href={`#${l.key}`}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-primary-100 cursor-pointer"
              >
                <i className={l.icon} />
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}